import React from 'react'
import styled from '@emotion/styled'
import { Button,Icon,Tooltip,Popconfirm } from 'antd'
import { ScanScore } from 'components/Score'
import ScanState from 'views/ScanSettings/Scans/components/ScanState'
import { navigate } from '@reach/router'
import Moment from 'react-moment';
import { ReactComponent as StopIcon } from '../../../../style/icons/stop_icon.svg'

import { colors } from 'style/theme'
import { red } from 'material-ui-colors'

const StyledCol = styled.span({
	fontWeight: 700,
	fontSize: '1rem'
})

const StyledError = styled(StyledCol)({
	color: colors.error.color
})

const StyledDate = styled(StyledCol)({
	color: colors.brandTextLight,
	fontSize: '0.8rem'
})

const DocumentCount = styled.div({
	color: colors.brandTextLight,
	fontSize: '1rem',
	fontWeight: 100
})

const Play = styled(Icon)({
	color: colors.brandGray,
	fontSize: 32
  })

  const StyleStopIcon = styled(StopIcon)`
  cursor:pointer;
  fill:grey;
  &:hover{fill:black;} 
`;


function OnStopScan(e,handleStopScan,id)
{
  e.target.setAttribute('disabled','true');
  e.target.style.fill = 'grey';
  handleStopScan(e, { id: id });
}

function ScansColumns(scanSettingsId, pageCount,handleStopScan) {
	return [
		{
			title:'',
			width: 32,
			render(state,scan) {
				return ((state.state === "Scanning" || state.state === "Pending") &&
				<Popconfirm title="Are you sure you want to stop the scan?" okText="Yes" cancelText="No" onConfirm={e => OnStopScan(e, handleStopScan, scan.id )}>
				<Tooltip placement="right" title='Stop Scan'>
					<StyleStopIcon width={32} height={32}/>
				</Tooltip>
				</Popconfirm>
				)
			}
		},
		{
			title: 'STATE',
			dataIndex: 'state',
			width: 200,
			render(state, scan) {
				let errors = scan && scan.error_description && !!scan.error_description.length && !!scan.error_description.filter((err) => err !== null).length
				errors = errors ? scan.error_description : null;
				return <ScanState error={state !== 'Complete' ? errors : null} state={state} completedCount={scan.successful_documents_count} pageCount={pageCount} />
			}
		},
		{
			title: 'SCORE',
			dataIndex: 'score',
			align: 'center',
			render(score, entity) {
				return (entity.state === "Complete" || entity.state === "Failed" || entity.state === "Stopped") && <ScanScore score={entity.state === "Complete" || entity.state === "Stopped" ? score : null} thickness={8} width={36} labelSize={14} />
			}
		},
		{
			title: 'COUNT',
			dataIndex: 'successful_documents_count',
			render(id, scan) {
				return (<DocumentCount>{scan.successful_documents_count} / {pageCount}</DocumentCount>)
			}
		},
		{
			title: 'DOCUMENT ERRORS',
			dataIndex: 'document_errors',
			align: 'center',
			key: 'document_errors',
			render(errors) {
				return <StyledError>{errors}</StyledError>
			}
		},
		{
			title: 'SELECTOR ERRORS',
			dataIndex: 'selector_errors',
			align: 'center',
			render(selector) {
				return <StyledCol>{selector}</StyledCol>
			}
		},
		{
			title: 'COMPLETE',
			key: 'complete_on',
			dataIndex: 'complete_on',
			render(date) {
				if(date) {
					return <StyledDate><Moment utc local fromNow>{date}</Moment></StyledDate>
				}
			}
		},
		{
			dataIndex: 'id',
			render(id) {
				return (
					<Button data-id="viewDocuments" icon="eye" type="link" block onClick={() => navigate(`/scan-settings/${scanSettingsId}/scan/${id}`)}>
						VIEW DOCUMENTS
					</Button>
				)
			}
		}
	]
}

export default ScansColumns
